export default {
    sim_providers_main_title: 'SIM Providers',
    sim_providers_main_id: 'Id',
    sim_providers_main_name: 'Name',
    sim_providers_add: 'Add SIM Provider',
}